import styled from 'styled-components';
import { BodyRegular, Card, Headline3 } from 'components/Elements';
import { breakpoints, sizes } from 'theme';
import strings from 'strings/strings.json';
import { LearnerCourseOverview } from '../../../models/LearnerCourseOverview';
import { useNavigate } from 'react-router-dom';
import CourseCardDateSection from './CourseCardDateSection';
import { formatLongDate } from 'lib/time-helpers';
import Button from 'components/buttons/Button';

type CourseCardProps = {
    courseOverview: LearnerCourseOverview;
};

export default function LearnerCourseCard({ courseOverview }: CourseCardProps): JSX.Element {
    const navigate = useNavigate();
    const linkTitle = strings.learnerCourseCard.linkTitle;
    const linkTitleAria = `${strings.learnerCourseCard.linkTitleAria}: ${courseOverview.title}`;
    const linkHref = `/learner/courses/${courseOverview.enrollmentId}/`;

    return (
        <CourseCard>
            <CourseTitleHeadine>{courseOverview.title}</CourseTitleHeadine>

            <CourseCardDateSection
                startDate={formatLongDate(courseOverview.startDate)}
                endDate={formatLongDate(courseOverview.endDate)}
                completedDate={courseOverview.completedDate}
                cancelled={!!courseOverview.cancelledDate}
                showEndDate={false}
            />

            <DescriptionText>{courseOverview.courseDescription}</DescriptionText>

            <Button
                title={linkTitle}
                aria={linkTitleAria}
                colour='PRIMARY'
                fullwidth
                onClick={() => {
                    navigate(linkHref);
                }}
            />
        </CourseCard>
    );
}

const CourseCard = styled(Card)`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    padding: ${sizes.spacingRg};
    border-radius: 30px;
    gap: ${sizes.spacingMd};
    text-align: left;
`;

const CourseTitleHeadine = styled(Headline3)`
    height: 5rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: anywhere;
    @media (max-width: ${breakpoints.sm}) {
        height: 5rem;
    }
`;

const DescriptionText = styled(BodyRegular)`
    height: 5rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: anywhere;
`;
